import { ConditionRule } from '@playbooks/core/src/interfaces/ActionCard'

function getIterationMethod(conditionRule?: ConditionRule): 'some' | 'every' | null {
  if (conditionRule === ConditionRule.OR) {
    return 'some'
  }

  if (conditionRule === ConditionRule.AND) {
    return 'every'
  }

  if (conditionRule === ConditionRule.None) {
    return null
  }

  return 'some'
}

export default getIterationMethod
